
export default {
  name: 'InplayEventController',
  values: {
    notificationsIdSearchParam: {
      name: '',
      value: '',
    },
  },
  meta: {
    extendable: false,
  },
}
